export default __webpack_public_path__ + "static/media/ico_chat.56463c66.svg";